export var createTestAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport = function createTestAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(createNativeAudioNode) {
  return function (nativeContext) {
    var nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    var nativeAudioBufferSourceNode = createNativeAudioNode(nativeContext, function (ntvCntxt) {
      return ntvCntxt.createBufferSource();
    });
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.start();
    nativeAudioBufferSourceNode.stop();

    try {
      nativeAudioBufferSourceNode.stop();
      return true;
    } catch (_unused) {
      return false;
    }
  };
};